function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var _require = require('./burn-fee-timing'),
  analyzeBundleReadiness = _require.analyzeBundleReadiness,
  getHeartbeatMs = _require.getHeartbeatMs,
  routingWorkNeeded = _require.routingWorkNeeded;
var _require2 = require('./manual-production-log'),
  logManualProduction = _require2.logManualProduction,
  logManualProductionError = _require2.logManualProductionError;
var _require3 = require('./timestamp-diagnostics'),
  fetchFreshTimestampPair = _require3.fetchFreshTimestampPair,
  logClockMismatchDetected = _require3.logClockMismatchDetected,
  logExplorerTimestampComparison = _require3.logExplorerTimestampComparison;
var MANUAL_PRODUCTION_POLL_MS = 500;
var CLOCK_MISMATCH_ABORT_AFTER = 5;
function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
function isBurnFeeTimingReady(readiness) {
  var workNeeded = routingWorkNeeded(readiness.burnfeeNolan, readiness.now, readiness.previousBlockTs, readiness.heartbeatMs);
  var workAvailable = Number(readiness.workAvailableNolan);
  if (workAvailable < workNeeded) {
    return false;
  }
  var previous = Number(readiness.previousBlockTs);
  var now = Number(readiness.now);
  if (now < previous + Number(readiness.forkDelayMs || 0)) {
    return false;
  }
  return true;
}
function formatReadiness(readiness, timingReady, readyToProduce) {
  var _readiness$mempoolTxC;
  var workNeeded = routingWorkNeeded(readiness.burnfeeNolan, readiness.now, readiness.previousBlockTs, readiness.heartbeatMs);
  return "burn-fee timing ready=".concat(timingReady, ", can bundle=").concat(readyToProduce, ", ") + "routing work available=".concat(readiness.workAvailableNolan, ", work needed=").concat(workNeeded, ", ") + "mempool tx count=".concat((_readiness$mempoolTxC = readiness.mempoolTxCount) !== null && _readiness$mempoolTxC !== void 0 ? _readiness$mempoolTxC : readiness.mempoolHasTx ? '>=1' : 0);
}

/**
 * Wait until burn-fee timing allows production, call produceOnce(), and retry
 * until block height exceeds startBlockId or the deadline passes.
 */
function waitForManualBlockProduction(_x, _x2, _x3) {
  return _waitForManualBlockProduction.apply(this, arguments);
}
function _waitForManualBlockProduction() {
  _waitForManualBlockProduction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, startBlockId, produceOnce) {
    var options,
      startId,
      heartbeatMs,
      deadline,
      startedAt,
      retryNumber,
      consecutiveClockMismatch,
      elapsedSec,
      latestBlockId,
      blockProduced,
      freshTimestamps,
      freshDiagnostic,
      readiness,
      timingReady,
      readyToProduce,
      produced,
      afterBlockId,
      producedBlock,
      _args = arguments,
      _t,
      _t2,
      _t3,
      _t4;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          options = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
          startId = Number(startBlockId) || 0;
          heartbeatMs = options.heartbeatMs || getHeartbeatMs(app);
          deadline = options.deadlineMs || Date.now() + Math.max(heartbeatMs * 4, 120000);
          startedAt = Date.now();
          retryNumber = 0;
          consecutiveClockMismatch = 0;
          logManualProduction("waitForManualBlockProduction entered (startBlockId=".concat(startId, ", deadline in ").concat(Math.max(heartbeatMs * 4, 120000), "ms)"));
          _context.p = 1;
        case 2:
          if (!(Date.now() < deadline)) {
            _context.n = 17;
            break;
          }
          retryNumber += 1;
          elapsedSec = ((Date.now() - startedAt) / 1000).toFixed(1);
          _t = Number;
          _context.n = 3;
          return app.blockchain.getLatestBlockId();
        case 3:
          latestBlockId = _t(_context.v);
          blockProduced = latestBlockId > startId;
          logManualProduction("wait retry #".concat(retryNumber, ": elapsed=").concat(elapsedSec, "s, current=").concat(latestBlockId, ", ") + "start=".concat(startId, ", block produced=").concat(blockProduced ? 'yes' : 'no'));
          if (!blockProduced) {
            _context.n = 4;
            break;
          }
          logManualProduction("New block observed: ".concat(latestBlockId));
          return _context.a(2, true);
        case 4:
          _context.n = 5;
          return fetchFreshTimestampPair(app);
        case 5:
          freshTimestamps = _context.v;
          freshDiagnostic = logExplorerTimestampComparison(freshTimestamps.previousBlockTs, freshTimestamps.now, {
            source: 'waitForManualBlockProduction (fresh read)',
            retryNumber: retryNumber
          });
          if (freshDiagnostic.misordered) {
            consecutiveClockMismatch += 1;
            logManualProduction("Clock misorder detected (".concat(consecutiveClockMismatch, "/").concat(CLOCK_MISMATCH_ABORT_AFTER, " consecutive)"));
          } else {
            consecutiveClockMismatch = 0;
          }
          if (!(consecutiveClockMismatch >= CLOCK_MISMATCH_ABORT_AFTER)) {
            _context.n = 6;
            break;
          }
          logClockMismatchDetected(freshDiagnostic, {
            blockHeight: latestBlockId,
            heartbeatMs: heartbeatMs,
            consecutiveCount: consecutiveClockMismatch
          });
          return _context.a(2, false);
        case 6:
          _context.n = 7;
          return analyzeBundleReadiness(app);
        case 7:
          readiness = _context.v;
          timingReady = isBurnFeeTimingReady(readiness);
          readyToProduce = readiness.mempoolHasTx ? readiness.canBundleNow : timingReady;
          logManualProduction("Waiting for new block (current=".concat(latestBlockId, ", start=").concat(startId, "); ").concat(formatReadiness(readiness, timingReady, readyToProduce)));
          if (readyToProduce) {
            _context.n = 9;
            break;
          }
          logManualProduction("Burn-fee not ready \u2014 sleeping ".concat(MANUAL_PRODUCTION_POLL_MS / 1000, "s"));
          _context.n = 8;
          return sleep(MANUAL_PRODUCTION_POLL_MS);
        case 8:
          return _context.a(3, 2);
        case 9:
          produced = false;
          _context.p = 10;
          _context.n = 11;
          return produceOnce();
        case 11:
          produced = _context.v;
          _context.n = 13;
          break;
        case 12:
          _context.p = 12;
          _t2 = _context.v;
          logManualProductionError('waitForManualBlockProduction.produceOnce', _t2);
          throw _t2;
        case 13:
          _t3 = Number;
          _context.n = 14;
          return app.blockchain.getLatestBlockId();
        case 14:
          afterBlockId = _t3(_context.v);
          producedBlock = produced || afterBlockId > startId;
          logManualProduction("wait retry #".concat(retryNumber, " after produceOnce: wallet returned=").concat(produced, ", ") + "current=".concat(afterBlockId, ", start=").concat(startId, ", block produced=").concat(producedBlock ? 'yes' : 'no'));
          if (!producedBlock) {
            _context.n = 15;
            break;
          }
          logManualProduction("New block observed: ".concat(afterBlockId));
          return _context.a(2, true);
        case 15:
          logManualProduction("Produce attempt returned false \u2014 retrying after ".concat(MANUAL_PRODUCTION_POLL_MS, "ms"));
          _context.n = 16;
          return sleep(MANUAL_PRODUCTION_POLL_MS);
        case 16:
          _context.n = 2;
          break;
        case 17:
          logManualProduction("waitForManualBlockProduction timed out (startBlockId=".concat(startId, ")"));
          return _context.a(2, false);
        case 18:
          _context.p = 18;
          _t4 = _context.v;
          logManualProductionError('waitForManualBlockProduction', _t4);
          throw _t4;
        case 19:
          return _context.a(2);
      }
    }, _callee, null, [[10, 12], [1, 18]]);
  }));
  return _waitForManualBlockProduction.apply(this, arguments);
}
module.exports = {
  waitForManualBlockProduction: waitForManualBlockProduction
};